/**
 * Modèle PlayerCondition - Identique à Flutter
 */

export interface PlayerCondition {
  typeName: string;
  attribute?: string | any; // Peut être string ou autre (comme Flutter)
  value?: string;
  groupNumber?: number; // Pour les groupes de conditions (AND/OR)
  path?: number; // Index du chemin associé
  [key: string]: any; // Pour les champs spécifiques au type
}

export const PlayerConditionFromJson = (json: any): PlayerCondition => {
  if (!json || typeof json.typeName !== 'string') {
    throw new Error('Invalid PlayerCondition JSON: missing typeName');
  }

  return {
    typeName: json.typeName,
    attribute: json.attribute,
    value: json.value,
    conditions: (json.conditions as any[])?.map((c) => PlayerConditionFromJson(c)),
    ...json, // Conserver tous les autres champs
  };
};
